// extracted by mini-css-extract-plugin
module.exports = {"section":"_396vaQwzSgQ174uBGttyc9","col":"_2Tgk8If5TH5quv4r1XJ3qF"};